import React, { useEffect, useState } from 'react';
import Header from '../Components/Header'
import DashBoardBodyVisa from '../Components/DashBoardBodyVisa';
import DashBoardHeader from '../Components/DashHeader';
import axios from "axios";
import { message } from 'antd';
import { useNavigate } from "react-router-dom";
import { Spin } from 'antd';

const baseURL = process.env.REACT_APP_API_BASE_URL;

const DashBoardVisa = () => {
  const navigate = useNavigate('');
  const [loginData, setLoginData] = useState({isreward: 0, cname: '', cnt: 0, draw: '', month: '',showprev: '', showlottnum: 0, link: '', isComfirm: 0});
  const [rewardData, setRewardData] = useState({reward: '', matchnum: '', lnum: ''});

  useEffect(() => {
    const items = JSON.parse(localStorage.getItem('localData'));
    if (items){
      if(items.type === "visa"){
        fetch(items);
      }else if(items.type === "saving"){
        navigate("/dashboardsaving")
      } else if (items.type === "apple"){
        navigate("/dashboardapple")
      }else if (items.type === "happypay"){
          navigate("/dashboardhappy")
      }
      else{
        localStorage.removeItem("localData");
        navigate("/login");
      }
    }else{
      message.info("Нэвтэрнэ үү.");
      navigate("/login");
    }
  }, []);

  const fetch = async (items) => {
    try {
      const response = await axios.post(`${baseURL}/happypay/index.php?cmd=dashboard`, items, {
        headers: {
          'Content-Type': 'application/json',
        }
      });

      let res = response.data
      if (res.status === true) {
        if(res.data.status === true){
          setLoginData(prevState => ({
            ...prevState, isreward:res.data.isreward, cname:res.data.cname,cnt:res.data.cnt,draw:res.data.draw, month: res.month, showprev: res.data.showprev, showlottnum: res.data.showlottnum, link: res.data.link, isComfirm: res.data.isComfirm
          }));

          setRewardData(prevState => ({
            ...prevState, reward:res.data.reward, matchnum:res.data.matchnum, lnum:res.data.lnum
          }));
        }else{
          message.error("Алдаа гарлаа.");
        }

      } else {
        localStorage.removeItem("localData");
        navigate("/login");
        message.error(res.msg);
      }

    } catch (error) {
      message.error("Алдаа гарлаа.");
    }
  }

  return (
    <div className='h-screen w-full mobile:h-fit tablet:h-fit laptop:h-full'>
      <Header />
      <div style={{ height: "calc(100% - 96px)" }} className='w-full px-40 py-8 bg-slate-200 space-y-8 mobile:px-4 laptop:px-20'>
        {loginData.cname !== '' ? (
          <>
            <DashBoardHeader name={loginData.cname ? loginData.cname : 'name'} />
            <DashBoardBodyVisa isComfirm={loginData.isComfirm} link={loginData.link !== '' ? loginData.link : ''} isshowlottnum={loginData.showlottnum ? loginData.showlottnum : 0} showprev={loginData.showprev ? loginData.showprev : '0'} month={loginData.month ? loginData.month : "10"} isReward={loginData.isreward ? loginData.isreward : 0} innRewardData={rewardData ? rewardData : null} lottNum={loginData.cnt ? loginData.cnt : 0} lottDrawDate={loginData.draw ? loginData.draw : '2023-01-01 00:00:00'} />
          </>) : (<Spin />)}
      </div>
    </div>
  );
}

export default DashBoardVisa;